import React, { useState } from "react";
import { Cell, Row } from "../../../../../components/Table";
import {
  formatDate,
  getMinutes,
  getPrintableTime,
  getStandradDateTime,
  utcToLocalTime,
} from "../../../../../lib/datetime";
import ListingPage from "../../../../../containers/ListingPage";
import UserActivityFilters from "../Filters";
import { getMessage } from "../../../../../lib/translator";
import { USER_ACTIVITY_LOGS_ENTITIES } from "./userActivityConstants";
import { objectDiff } from "../../../../../utils/objectDiff";
import isEmpty from "lodash.isempty";
import emptyIcon from "./logs-empty.svg";
import capitalize from "lodash.capitalize";
const tableProperties = (entityName) => {
  const actionText = (newValue, oldValue) => {
    if (isEmpty(newValue) && !isEmpty(oldValue)) {
      return "Deleted";
    } else if (!isEmpty(newValue) && isEmpty(oldValue)) {
      return "Created";
    } else if (!isEmpty(newValue) && !isEmpty(oldValue)) {
      const updatedFields = objectDiff(newValue, oldValue);
      if (updatedFields.status) {
        return `Status changed from ${capitalize(
          oldValue.status
        )} to ${capitalize(newValue.status)} for ${formatDate(newValue.date)} `;
      }
      const modifiedMessage = Object.keys(updatedFields).reduce(
        (modifiedStr, key, index) => {
          if (index > 0) {
            return modifiedStr.concat(", " + key);
          }
          return modifiedStr.concat(key);
        },
        ""
      );
      return modifiedMessage.concat(" Modified");
    }
    return "";
  };

  const getEntityLabel = (entityType, newValue, oldValue) => {
    const slotEntities = ["SlotBlocking", "Slot"];

    if (slotEntities.includes(entityType)) {
      const startTime = newValue?.startTime || oldValue?.startTime;
      const endTime = newValue?.endTime || oldValue?.endTime;

      if (startTime && endTime) {
        const today = new Date().toISOString().split("T")[0];
        const formattedStart = getPrintableTime(
          getStandradDateTime(utcToLocalTime, `${today} ${startTime}`)
        )
          .split(",")[1]
          .trim();
        const formattedEnd = getPrintableTime(
          getStandradDateTime(utcToLocalTime, `${today} ${endTime}`)
        )
          .split(",")[1]
          .trim();

        return `"${formattedStart} - ${formattedEnd}"`;
      } else {
        const end = newValue?.endTime || oldValue?.endTime;
        return `"${getMessage("slots.asap")} ${getMinutes(end)} ${getMessage(
          "slots.asap.minute"
        )}"`;
      }
    }

    const name = newValue?.name || oldValue?.name;
    return name ? `"${name}"` : "";
  };

  const getTableHeader = (entityName) => {
    const entity = USER_ACTIVITY_LOGS_ENTITIES.find(
      (currentEntity) => currentEntity.value === entityName
    );
    const tableHeaders = [
      "Select Entity",
      entity?.tableNameHeader ? ` ${entityName} Name` : false,
      "User",
      "Date",
      "Action",
    ].filter(Boolean);
    tableHeaders.push("");
    return tableHeaders;
  };
  return {
    headers: getTableHeader(entityName),
    row: (props) => {
      const {
        entityType,
        id,
        newValue,
        oldValue,
        user,
        createdAt,
        entityId,
        UserName,
        actionTime,
      } = props;
      const excludedEntityTypes = [
        "LogisticsSettings",
        "PaymentMethod",
        "OrderConfigs",
      ];

      return (
        <Row key={id}>
          <Cell>{entityType}</Cell>
          {(newValue?.name || oldValue?.name) && (
            <Cell>{newValue?.name || oldValue?.name}</Cell>
          )}
          <Cell>{user?.name || UserName}</Cell>
          <Cell>
            {createdAt
              ? getPrintableTime(getStandradDateTime(utcToLocalTime, createdAt))
              : actionTime
              ? getPrintableTime(
                  getStandradDateTime(utcToLocalTime, actionTime)
                )
              : null}
          </Cell>
          <Cell>
            {entityType}{" "}
            {entityType === "Capacity" &&
              (newValue?.capacity || oldValue?.capacity) && (
                <span className="bold">
                  {newValue?.capacity || oldValue?.capacity}{" "}
                </span>
              )}
            {!excludedEntityTypes?.includes(entityType) && (
              <span className="bold">
                {getEntityLabel(entityType, newValue, oldValue)}
              </span>
            )}{" "}
            {actionText(newValue, oldValue).split(" ").slice(0, -1).join(" ")}{" "}
            <span className="bold">
              {actionText(newValue, oldValue).split(" ").slice(-1)[0]} (ID:{" "}
              {entityId})
            </span>
          </Cell>
          <Cell>{""}</Cell>
        </Row>
      );
    },
  };
};

const emptyState = {
  icon: emptyIcon,
};

function UserActivityLogsTable() {
  const [currentEntity] = useState();
  const [entityName, setEntityName] = useState();

  return (
    <>
      <ListingPage
        api={{
          url: currentEntity?.url,
          transform: (response) => {
            if (!response.data || !response.data.history) return [];
            setEntityName(response.data.history?.[0]?.entityType);
            return response.data.history || [];
          },
        }}
        filters={{
          component: UserActivityFilters,
          showFiltersOnLoad: true,
          transformSubmit: (formData) => {
            const result = { ...formData };
            if (!result.entityType) {
              result.entityType = "Store";
            }
            if (result.entityType === "Store" && result.storeId) {
              result.entityId = result.storeId;
              delete result.storeId;
            }
            if (result.dateRange) {
              result.startDate = result.dateRange.startDate;
              result.endDate = result.dateRange.endDate;
              delete result.dateRange;
            }
            return result;
          },
        }}
        emptyState={emptyState}
        title={getMessage("menu.item.user-activity-logs")}
        className="user-activity-logs"
        tableProperties={tableProperties(entityName)}
        onClear={function () {
          this.setState((prev) => {
            const data = {
              ...prev.data,
              items: [],
            };
            return {
              data,
            };
          });
        }}
      />
    </>
  );
}

export default UserActivityLogsTable;
